import { ConfirmDeleteDialog } from '@/components/ConfirmDeleteDialog';
import { useDeleteOrder } from '@/hooks/useOrderActions';
import { useRetainedValue } from '@/hooks/useRetainedValue';
import type { Order } from '@octave/contracts';

interface DeleteOrderDialogProps {
  /** The order to delete; the dialog is closed when null. */
  order: Order | null;
  onClose: () => void;
}

/** Octave admin: confirm the deletion of an order. */
export function DeleteOrderDialog({ order, onClose }: DeleteOrderDialogProps) {
  const { mutate: deleteOrder, isPending } = useDeleteOrder();
  const shown = useRetainedValue(order);

  const confirm = () => {
    if (!order) return;
    deleteOrder(order.id, { onSuccess: onClose });
  };

  return (
    <ConfirmDeleteDialog
      open={order !== null}
      title="Supprimer la commande"
      description={
        <>
          Êtes-vous sûr de vouloir supprimer la commande{' '}
          <strong>{shown?.orderNumber}</strong> ? Les eSIM internationales qui
          n'ont pas d'autre forfait sont supprimées avec elle. Cette action est
          irréversible.
        </>
      }
      isPending={isPending}
      onConfirm={confirm}
      onCancel={onClose}
    />
  );
}
